import React from "react";
import { useTranslation } from "react-i18next";
import { List } from "semantic-ui-react";

export default function GeneralRateCell(props) {
  const { t } = useTranslation();
  return (
    <div className="mt-[-13px]">
      <List size="large" className="text-[13px]">
        {props.activation_date ? (
          <List.Item>
            <List.Content className="flex gap-1" >
              <List.Description className="font-semibold text-[13px] text-gray-950">{t("date_active_rate")}:</List.Description>
              <List.Description className="text-[13px]">{props.activation_date}</List.Description>
            </List.Content>
          </List.Item>
        ) : (
          null
        )}

        {props.inactivation_date ? (
          <List.Item>
            <List.Content className="flex gap-1">
              <List.Description className="font-semibold text-[13px]">{t("date_deactivate_rate")}</List.Description>
              <List.Description className="text-[13px]">{props.inactivation_date}</List.Description>
            </List.Content>
          </List.Item>
        ) : (
          null
        )}
        {
          props.reason_deactivation ?
            <List.Item>
              <List.Content>
                <div className="flex gap-2 items-center"> <p className="font-semibold">{t("reason_deactivation")}:</p>{props.reason_deactivation}</div>
              </List.Content>
            </List.Item> : " "
        }

      </List>
    </div>
  );
}
